import { Controller } from 'stimulus'
import $ from 'jquery'

var $global = typeof window !== 'undefined' && (window.jQuery || window.$) ? window.jQuery || window.$ : $

export default class extends Controller {
  static get targets() {
    return ['paymentsContainer']
  }

  connect() {
    this.paymentIndex = 0
    this.setupRemoveListeners()
    this.validationTimeouts = {}
    this.hasInstallments = false
    this.errorsCount = 0
    this.showNsu = this.element.dataset.paymentInstallmentsShowNsu === 'true'
    this.initializeExistingInstallments()
    this.setupFormSubmitListener()
    this.ensureParentTotalsRecalculated()
    this.manageBilletAvailability()
  }

  ensureParentTotalsRecalculated() {
    // After form error, ensure all parent totals are recalculated
    var self = this
    var paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    var parentRows = paymentsContainer.querySelectorAll('tr.nested-fields')
    parentRows.forEach(function(row) {
      // Check if this parent has installments
      var installmentRows = self.getInstallmentRows(row)
      if (installmentRows.length > 0) {
        // Recalculate parent total from installment values
        self.recalculateParentTotal(row)
      }
    })
  }

  initializeExistingInstallments() {
    var self = this
    setTimeout(function() {
      var installmentWrappers = document.querySelectorAll('.installments-fields-wrapper')

      installmentWrappers.forEach(function(wrapper) {
        self.initializeUIComponents(wrapper, wrapper.closest('.installments-container'))
      })
    }, 100)
  }

  setupRemoveListeners() {
    var self = this

    // Listener para click no botão remover
    $(this.paymentsContainerTarget).on('click', '.remove_fields', function(event) {
      var parentRow = $(this).closest('.nested-fields')[0]
      if (!parentRow) return

      self.clearInstallmentFields(parentRow)
    })

    // Listener para cocoon:after-remove
    $(this.paymentsContainerTarget).on('cocoon:after-remove.paymentInstallments', function(e) {
      setTimeout(function() {
        self.manageBilletAvailability()
        self.refreshAllDropdowns()
      }, 300)
    })

    // Listener para evento custom paymentChanged
    window.addEventListener('paymentChanged', function() {
      setTimeout(function() {
        self.manageBilletAvailability()
      }, 50)
    })
  }

  handleInstallmentsChange(event) {
    var installmentsValue = parseInt(event.target.value) || 1
    var parentRow = event.target.closest('.nested-fields')
    if (!parentRow) return

    var parentMethod = this.getPaymentMethod(parentRow)
    if (parentMethod !== 'billet') return

    // Reset error count when changing installments
    this.errorsCount = 0

    // Clear all error classes from all installment fields
    var allErrorFields = document.querySelectorAll('tr.installment-row .field.error, tr.nested-fields .field.error')
    allErrorFields.forEach(function(field) {
      field.classList.remove('error')
      var errorMsg = field.querySelector('.error-message')
      if (errorMsg) {
        errorMsg.textContent = ''
        errorMsg.style.display = 'none'
      }
    })

    this.buildInstallmentFields(parentRow, installmentsValue, parentMethod)
    this.disableParentPayment(parentRow)
    this.updateParentInstallments(parentRow, installmentsValue)
    this.hasInstallments = true
    this.disableAllBilletInstallments(event.target.closest('tr.nested-fields'))

    this.recalculateParentTotal(parentRow)
    // Update button state after changing installments
    this.updateSubmitButton()

    // Notify box-payment about installment change to recalculate button state
    var self = this
    setTimeout(function() {
      window.dispatchEvent(new CustomEvent('paymentChanged'))
    }, 100)
  }

  handlePaymentMethodChange(event) {
    var parentRow = event.target.closest('.nested-fields')
    if (!parentRow) return

    // Se mudou para um método que não é billet, limpar campos de parcelas
    if (event.target.value !== 'billet') {
      this.clearInstallmentFields(parentRow)
      this.enableParentPayment(parentRow)
      this.updateParentInstallments(parentRow, 1)
    } else {
      var installmentsSelect = parentRow.querySelector('select[name*="[installments]"]')
      var installmentsValue = installmentsSelect ? parseInt(installmentsSelect.value, 10) || 1 : 1

      this.buildInstallmentFields(parentRow, installmentsValue, event.target.value)
      this.disableParentPayment(parentRow)
      this.updateParentInstallments(parentRow, installmentsValue)
    }

    this.updateHasInstallments()
    this.manageBilletAvailability()

    if (this.hasInstallments && event.target.value == 'billet') {
      var $installmentsSelect = $(event.target)
        .parents('tr')
        .find('select[name*="[installments]"]')
      $installmentsSelect.find('option[data-value="1"]').trigger('click')
      $installmentsSelect.attr('data-disabled', 'disabled')
      $installmentsSelect.children().addClass('disabled')
    }
  }

  hasOtherBillet(currentSelect) {
    var paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return false

    var paymentRows = paymentsContainer.querySelectorAll('tr.nested-fields:not(.installment-row)')

    for (var i = 0; i < paymentRows.length; i++) {
      var row = paymentRows[i]
      var methodSelect = row.querySelector('select[name*="[payment_method]"]')
      var destroyField = row.querySelector('input[name*="[_destroy]"]')

      // Pular a linha atual
      if (methodSelect === currentSelect) continue

      // Pular linhas marcadas para destruição
      if (destroyField && destroyField.value === 'true') continue

      // Se encontrou outro billet, retornar true
      if (methodSelect && methodSelect.value === 'billet') {
        return true
      }
    }

    return false
  }


  refreshAllDropdowns() {
    var paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    var paymentRows = paymentsContainer.querySelectorAll('tr.nested-fields:not(.installment-row)')

    paymentRows.forEach(function(row) {
      var methodSelect = row.querySelector('select[name*="[payment_method]"]')
      if (!methodSelect) return

      // Apenas fazer refresh para atualizar a lista sem destruir
      $(methodSelect).dropdown('refresh')
    })
  }

  manageBilletAvailability() {
    var self = this
    var paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    var paymentRows = Array.from(paymentsContainer.querySelectorAll('tr.nested-fields:not(.installment-row)'))

    // Verificar se existe algum billet selecionado e não marcado para destruição
    var billetRowIndex = -1
    paymentRows.forEach(function(row, index) {
      var methodSelect = row.querySelector('select[name*="[payment_method]"]')
      var destroyField = row.querySelector('input[name*="[_destroy]"]')

      if (methodSelect && methodSelect.value === 'billet' && (!destroyField || destroyField.value !== 'true')) {
        billetRowIndex = index
      }
    })

    // Gerenciar opção de billet em todos os selects
    paymentRows.forEach(function(row, index) {
      var methodSelect = row.querySelector('select[name*="[payment_method]"]')
      if (!methodSelect) return

      var billetOption = methodSelect.querySelector('option[value="billet"]')
      var billetBackup = paymentsContainer.querySelector('[data-billet-option-backup]')

      if (billetRowIndex !== -1) {
        // Existe um billet selecionado
        if (index !== billetRowIndex) {
          // Esta linha NÃO tem billet: remover a opção
          if (billetOption && !row.querySelector('[data-billet-option-backup]')) {
            var backup = billetOption.cloneNode(true)
            backup.setAttribute('data-billet-option-backup', 'true')
            backup.style.display = 'none'
            row.appendChild(backup)
            billetOption.remove()
          }
        } else {
          // Esta é a linha com billet: garantir que tem a opção
          if (!billetOption && billetBackup) {
            var restored = billetBackup.cloneNode(true)
            restored.removeAttribute('data-billet-option-backup')
            restored.style.display = ''
            methodSelect.appendChild(restored)
            billetBackup.remove()
          }
        }
      } else {
        // Não há billet: restaurar a opção em todos os selects
        var localBackup = row.querySelector('[data-billet-option-backup]')
        if (localBackup && !billetOption) {
          var restored = localBackup.cloneNode(true)
          restored.removeAttribute('data-billet-option-backup')
          restored.style.display = ''
          methodSelect.appendChild(restored)
          localBackup.remove()
        }
      }
    })
  }

  updateHasInstallments() {
    this.hasInstallments = $('#payments_tab tr.installment-row').length > 0
  }

  disableAllBilletInstallments(exceptionRow) {
    var self = this
    setTimeout(function() {
      $('#payments_tab tr.nested-fields').each(function(_, row) {
        if (row === exceptionRow) return

        self.disableBilletInstallment(row)
      })
    }, 100)
  }

  disableBilletInstallment(eventTarget) {
    var paymentMethod = $(eventTarget).find('select[name*="[payment_method]"]')[0].value

    if (this.hasInstallments && paymentMethod == 'billet') {
      var installmentContainer = eventTarget.querySelector('.order_payments_installments')
      var installmentsSelect = eventTarget.querySelector('select[name*="[installments]"]')
      installmentsSelect.setAttribute('data-disabled', 'disabled')
      installmentContainer.classList.add('disabled')
    }
  }

  enableAllBilletInstallments(exceptionRow) {
    var self = this
    setTimeout(function() {
      $('#payments_tab tr.nested-fields').each(function(_, row) {
        if (row === exceptionRow) return

        self.enableBilletInstallment(row)
      })
    }, 100)
  }

  enableBilletInstallment(eventTarget) {
    var installmentContainer = eventTarget.querySelector('.order_payments_installments')
    var installmentsSelect = eventTarget.querySelector('select[name*="[installments]"]')
    installmentsSelect.removeAttribute('data-disabled')
    installmentContainer.classList.remove('disabled')
  }

  getOrCreateInstallmentsContainer(parentRow) {
    return parentRow
  }

  getPaymentId(row) {
    if (!row.dataset.paymentId) {
      row.dataset.paymentId =
        'payment_' +
        Date.now() +
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9)
    }
    return row.dataset.paymentId
  }

  clearInstallmentFields(parentRow) {
    var nextRow = parentRow.nextElementSibling
    while (nextRow && nextRow.classList.contains('installment-row')) {
      // Clear any error classes before removing
      var errorFields = nextRow.querySelectorAll('.field.error')
      errorFields.forEach(function(field) {
        field.classList.remove('error')
      })

      var rowToRemove = nextRow
      nextRow = nextRow.nextElementSibling
      rowToRemove.remove()
    }
  }

  buildInstallmentFields(parentRow, installmentsCount, paymentMethod) {
    var existingValues = this.getExistingInstallmentValues(parentRow)
    if (existingValues.length === 0) {
      existingValues = this.buildInitialInstallmentValues(parentRow, installmentsCount)
    }

    this.clearInstallmentFields(parentRow)

    var timestamp = Date.now()
    var baseIndex = timestamp

    for (var i = 1; i <= installmentsCount; i++) {
      var index = baseIndex + i - 1
      var existing = existingValues[i - 1]
      var value = existing && typeof existing.value !== 'undefined' ? existing.value : 0

      var date
      if (existing && typeof existing.date !== 'undefined' && existing.date) {
        // Use existing date if available
        date = existing.date
      } else if (installmentsCount === 1) {
        // Single installment: leave due date empty for user to fill
        date = ''
      } else if (i > 1 && existingValues.length > 0) {
        // New installment: calculate based on last existing date
        var lastExistingDate = existingValues[existingValues.length - 1].date
        if (lastExistingDate) {
          date = this.calculateNextDueDate(lastExistingDate, i - existingValues.length)
        } else {
          date = this.calculateDueDate(i)
        }
      } else {
        // No existing dates: use default calculation
        date = this.calculateDueDate(i)
      }

      var row = this.buildInstallmentField(i, installmentsCount, value, paymentMethod, index, date)

      var lastInstallmentRow = this.getLastInstallmentRow(parentRow)
      if (lastInstallmentRow) {
        lastInstallmentRow.parentNode.insertBefore(row, lastInstallmentRow.nextSibling)
      } else {
        parentRow.parentNode.insertBefore(row, parentRow.nextSibling)
      }
    }

    this.initializeUIComponents(parentRow)
  }

  getLastInstallmentRow(parentRow) {
    var nextRow = parentRow.nextElementSibling
    var lastInstallmentRow = null

    while (nextRow && nextRow.classList.contains('installment-row')) {
      lastInstallmentRow = nextRow
      nextRow = nextRow.nextElementSibling
    }

    return lastInstallmentRow
  }

  getExistingInstallmentValues(parentRow) {
    var values = []
    var nextRow = parentRow.nextElementSibling

    while (nextRow && nextRow.classList.contains('installment-row')) {
      var hiddenInput = nextRow.querySelector('.installment-total-input')
      var dateInput = nextRow.querySelector('.installment-date-input')

      values.push({
        value: hiddenInput ? parseFloat(hiddenInput.value) || 0 : 0,
        date: dateInput ? dateInput.value : '',
      })

      nextRow = nextRow.nextElementSibling
    }

    return values
  }

  buildInitialInstallmentValues(parentRow, installmentsCount) {
    var parentHiddenInput = parentRow.querySelector('input[name*="[total]"]')
    var parentTotal = parentHiddenInput ? parseFloat(parentHiddenInput.value) || 0 : 0

    if (installmentsCount !== 1 || parentTotal <= 0) return []

    return [{ value: parentTotal, date: '' }]
  }

  calculateDueDate(installmentNumber) {
    function pad2(n) {
      return n < 10 ? '0' + n : '' + n
    }

    var dueDate = new Date()
    dueDate.setHours(0, 0, 0, 0)

    dueDate.setDate(dueDate.getDate() + 1)

    if (installmentNumber > 1) {
      dueDate.setDate(dueDate.getDate() + 30 * (installmentNumber - 1))
    }

    if (dueDate.getDate() === 31) {
      dueDate.setDate(dueDate.getDate() + 1)
    }

    var day = pad2(dueDate.getDate())
    var month = pad2(dueDate.getMonth() + 1)
    var year = dueDate.getFullYear()

    return day + '/' + month + '/' + year
  }

  calculateNextDueDate(baseDate, numberOfInstallments) {
    function pad2(n) {
      return n < 10 ? '0' + n : '' + n
    }

    // Parse the base date in format DD/MM/YYYY
    var parts = baseDate.split('/')
    if (parts.length !== 3) return baseDate

    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10) - 1
    var year = parseInt(parts[2], 10)

    var dueDate = new Date(year, month, day)
    dueDate.setHours(0, 0, 0, 0)

    // Add 30 days for each installment after the base
    dueDate.setDate(dueDate.getDate() + 30 * numberOfInstallments)

    // Handle month overflow
    if (dueDate.getDate() === 31) {
      dueDate.setDate(dueDate.getDate() + 1)
    }

    var resultDay = pad2(dueDate.getDate())
    var resultMonth = pad2(dueDate.getMonth() + 1)
    var resultYear = dueDate.getFullYear()

    return resultDay + '/' + resultMonth + '/' + resultYear
  }

  initializeUIComponents(parentRow) {
    var self = this
    setTimeout(function() {
      var installmentRows = self.getInstallmentRows(parentRow)

      installmentRows.forEach(function(row) {
        row.querySelectorAll('.ui.dropdown').forEach(function(el) {
          $(el).dropdown({ showOnFocus: false })
        })

        row.querySelectorAll('.ui.calendar').forEach(function(el) {
          if (typeof addCalendarTo !== 'undefined') {
            addCalendarTo(el)
            return
          }

          if ($global && $global.fn && typeof $global.fn.calendar === 'function') {
            $global(el).calendar({
              type: 'date',
            })
          }
        })

        row.querySelectorAll('[data-controller="mask"]').forEach(function(el) {
          var input = el.querySelector('[data-target="mask.input"]')
          var hiddenInput = el.querySelector('[data-target="mask.hiddenInput"]')

          if (input && hiddenInput) {
            var value = parseFloat(hiddenInput.value) || 0
            input.value = value.toFixed(2).replace('.', ',')
          }
        })
      })

      self.recalculateParentTotal(parentRow)
    }, 50)
  }

  buildInstallmentField(number, total, value, paymentMethod, index, date = '') {
    var formattedValue = parseFloat(value).toFixed(2)
    var dueDate = date

    var row = document.createElement('tr')
    row.className = 'installment-row'

    var totalColspan = this.showNsu ? '2' : '1'
    var gapColspan = this.showNsu ? '2' : '1'

    /* eslint-disable max-len */
    row.innerHTML = `
      <td colspan="${gapColspan}" style="padding: 0;"></td>

      <td colspan="${totalColspan}" class="field installment-total-field" data-controller="mask" data-mask-type="currency">
        <label class="installment-number-label" for="order_payments_attributes_${index}_total">Parcela ${number}</label>
        <input value="${formattedValue.replace('.', ',')}"
               class="installment-value-input"
               data-target="mask.input"
               data-action="input->mask#format input->payment-installments#handleValueChange blur->payment-installments#validateTotal"
               type="text"
               name="order[payments_attributes][${index}][total]"
               id="order_payments_attributes_${index}_total">
        <input value="${formattedValue}"
               class="installment-total-input"
               data-target="mask.hiddenInput"
               type="hidden"
               name="order[payments_attributes][${index}][total]"
               id="order_payments_attributes_${index}_total">
        <span class="error-message" style="display: none; color: #9f3a38; font-size: 0.92857143em; margin-top: 0.25em;"></span>
      </td>

      <td colspan="2" class="field installment-date-field ui calendar date" data-controller="mask" data-mask-type="dateFormat">
        <label>Vencimento</label>
        <input value="${dueDate}"
               class="installment-date-input"
               data-target="mask.input"
               data-action="blur->payment-installments#validateDate"
               type="text"
               name="order[payments_attributes][${index}][billet_expiration_date]"
               id="order_payments_attributes_${index}_billet_expiration_date">
        <span class="error-message" style="display: none; color: #9f3a38; font-size: 0.92857143em; margin-top: 0.25em;"></span>
      </td>

      <input value="${paymentMethod}" class="installment-method-input" type="hidden" name="order[payments_attributes][${index}][payment_method]" id="order_payments_attributes_${index}_payment_method">
      <input value="true" class="installment-billet-input" type="hidden" name="order[payments_attributes][${index}][installment_billet]" id="order_payments_attributes_${index}_installment_billet">
      <input value="1" class="installment-count-input" type="hidden" name="order[payments_attributes][${index}][installments]" id="order_payments_attributes_${index}_installments">
      <input value="false" class="installment-destroy-input" type="hidden" name="order[payments_attributes][${index}][_destroy]" id="order_payments_attributes_${index}__destroy">
    `
    /* eslint-enable max-len */

    return row
  }

  handleValueChange(event) {
    var installmentRow = event.target.closest('tr.installment-row')
    if (!installmentRow) return

    var parentRow = this.getParentRow(installmentRow)
    if (!parentRow) return

    this.recalculateParentTotal(parentRow)

    // Auto-validate date field when value changes
    var dateInput = installmentRow.querySelector('.installment-date-input')
    if (dateInput) {
      this.validateDate({ target: dateInput })
    }

    // Update button state
    this.updateSubmitButton()
  }

  recalculateParentTotal(parentRow) {
    var self = this
    var installmentRows = this.getInstallmentRows(parentRow)

    var parentHiddenInput = parentRow.querySelector('input[name*="[total]"]')
    var parentVisibleInput = parentRow.querySelector('[data-target*="mask.input"]')

    if (installmentRows.length > 0) {
      // Parent payment with installments should have total = sum of all installments
      var total = 0
      installmentRows.forEach(function(row) {
        var input = row.querySelector('.installment-total-input')
        if (input && input.value) {
          total += parseFloat(input.value) || 0
        }
      })

      // Only update if we have a valid total
      if (total > 0 || installmentRows.length === 0) {
        if (parentHiddenInput) {
          parentHiddenInput.value = total.toFixed(2)
        }
        if (parentVisibleInput) {
          var formattedValue = total.toFixed(2).replace('.', ',')
          parentVisibleInput.value = formattedValue
          parentVisibleInput.dispatchEvent(new Event('input', { bubbles: true }))
        }
        // Notify box-payment-controller about the value change
        setTimeout(function() {
          window.dispatchEvent(new CustomEvent('paymentChanged'))
        }, 50)
      }
    } else {
      // Parent payment without installments: user fills in manually
      // Preserve existing value and don't clear it
      if (parentHiddenInput && !parentHiddenInput.value) {
        // Only fill if empty and there's a visible value
        if (parentVisibleInput && parentVisibleInput.value) {
          parentHiddenInput.value = parentVisibleInput.value.replace(',', '.')
        }
      }
    }
  }

  updateParentInstallments(parentRow, installmentsCount) {
    // Update both visible and hidden installments fields on parent payment
    var installmentsHidden = parentRow.querySelector('input[name*="[installments]"]')
    var installmentsSelect = parentRow.querySelector('select[name*="[installments]"]')

    if (installmentsHidden) {
      installmentsHidden.value = installmentsCount
    }

    if (installmentsSelect) {
      installmentsSelect.value = installmentsCount
    }
  }

  getInstallmentRows(parentRow) {
    var rows = []
    var nextRow = parentRow.nextElementSibling

    while (nextRow && nextRow.classList.contains('installment-row')) {
      rows.push(nextRow)
      nextRow = nextRow.nextElementSibling
    }

    return rows
  }

  getParentRow(installmentRow) {
    var prevRow = installmentRow.previousElementSibling

    while (prevRow && prevRow.classList.contains('installment-row')) {
      prevRow = prevRow.previousElementSibling
    }

    return prevRow
  }

  getPaymentMethod(row) {
    var methodSelect = row.querySelector('select[name*="[payment_method]"]')
    return methodSelect ? methodSelect.value : ''
  }

  disableParentPayment(parentRow) {
    // Only disable the visible total input, not the hidden field or installments
    var visibleTotalInput = parentRow.querySelector('[data-target*="mask.input"]')
    if (visibleTotalInput) {
      visibleTotalInput.disabled = true
    }
  }

  enableParentPayment(parentRow) {
    // Enable the visible total input
    var visibleTotalInput = parentRow.querySelector('[data-target*="mask.input"]')
    if (visibleTotalInput) {
      visibleTotalInput.disabled = false
    }
  }

  validateTotal(event) {
    var input = event.target
    var field = input.closest('.installment-total-field')
    if (!field) return

    var hiddenInput = field.querySelector('.installment-total-input')
    var value = parseFloat(hiddenInput.value) || 0

    var hadError = field.classList.contains('error')
    this.clearFieldError(field)

    if (value <= 0) {
      this.setFieldError(field, 'O valor deve ser maior que zero')
      this.disableSaveButton()
      if (!hadError) {
        this.errorsCount += 1
      }
      return false
    }

    if (hadError) {
      this.clearFieldError(field)
      this.errorsCount = Math.max(0, this.errorsCount - 1)
      if (this.errorsCount === 0) {
        this.enableSaveButton()
      }
    }

    // Ensure button state is updated after validation
    this.updateSubmitButton()

    return true
  }

  validateDate(event) {
    var input = event.target
    var field = input.closest('.installment-date-field')
    if (!field) return

    var installmentRow = input.closest('tr.installment-row')
    if (!installmentRow) return

    var parentRow = this.getParentRow(installmentRow)
    if (!parentRow) return

    var dateValue = input.value
    var hadError = field.classList.contains('error')
    this.clearFieldError(field)

    if (!dateValue || dateValue.trim() === '') {
      if (this.getInstallmentRows(parentRow).length === 1) {
        this.updateSubmitButton()
        return true
      }

      // Auto-fill with default date based on installment position
      var installmentRows = this.getInstallmentRows(parentRow)
      var installmentIndex = installmentRows.indexOf(installmentRow)
      var defaultDate = this.calculateDueDate(installmentIndex + 1)
      input.value = defaultDate
      dateValue = defaultDate
    }

    var date = this.parseDate(dateValue)
    if (!date) {
      this.setFieldError(field, 'Data inválida')
      this.disableSaveButton()
      if (!hadError) {
        this.errorsCount += 1
      }
      return false
    }

    var today = new Date()
    today.setHours(0, 0, 0, 0)

    if (date < today) {
      this.setFieldError(field, 'A data deve ser a partir de hoje')
      this.disableSaveButton()
      if (!hadError) {
        this.errorsCount += 1
      }
      return false
    }

    var twoYearsFromNow = new Date()
    twoYearsFromNow.setFullYear(twoYearsFromNow.getFullYear() + 2)
    twoYearsFromNow.setHours(23, 59, 59, 999)

    if (date > twoYearsFromNow) {
      this.setFieldError(field, 'A data não pode ser superior a 2 anos no futuro')
      this.disableSaveButton()
      if (!hadError) {
        this.errorsCount += 1
      }
      return false
    }

    var installmentRows = this.getInstallmentRows(parentRow)
    var currentIndex = installmentRows.indexOf(installmentRow)

    if (currentIndex > 0) {
      var previousRow = installmentRows[currentIndex - 1]
      var previousDateInput = previousRow.querySelector('.installment-date-input')
      var previousDate = this.parseDate(previousDateInput.value)

      if (previousDate && date < previousDate) {
        this.setFieldError(field, 'A data não pode ser anterior à parcela anterior')
        this.disableSaveButton()
        if (!hadError) {
          this.errorsCount += 1
        }
        return false
      }
    }

    if (currentIndex < installmentRows.length - 1) {
      var nextRow = installmentRows[currentIndex + 1]
      var nextDateInput = nextRow.querySelector('.installment-date-input')
      var nextDate = this.parseDate(nextDateInput.value)

      if (nextDate && nextDate < date) {
        var nextField = nextDateInput.closest('.installment-date-field')
        this.clearFieldError(nextField)
        this.validateDateField(nextDateInput)
      }
    }

    if (hadError) {
      this.errorsCount = Math.max(0, this.errorsCount - 1)
      if (this.errorsCount === 0) {
        this.enableSaveButton()
      }
    }

    // Ensure button state is updated after validation
    this.updateSubmitButton()

    return true
  }

  validateDateField(input) {
    var event = { target: input }
    this.validateDate(event)
  }

  removeErrorAndValidate() {
    if (this.errorsCount <= 0) return

    this.errorsCount -= 1
    if (this.errorsCount === 0) this.enableSaveButton()
  }

  disableSaveButton() {
    var submitButton = document.querySelector('button[form="new-budget-order"]')
    if (submitButton) {
      submitButton.classList.add('is-disabled')
    }
  }

  enableSaveButton() {
    var submitButton = document.querySelector('button[form="new-budget-order"]')
    if (submitButton) {
      submitButton.classList.remove('is-disabled')
    }
  }

  parseDate(dateString) {
    if (!dateString) return null

    var parts = dateString.split('/')
    if (parts.length !== 3) return null

    var day = parseInt(parts[0], 10)
    var month = parseInt(parts[1], 10) - 1
    var year = parseInt(parts[2], 10)

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null

    var date = new Date(year, month, day)

    if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) {
      return null
    }

    return date
  }

  setFieldError(field, message) {
    field.classList.add('error')
    var input = field.querySelector('input')
    if (input) {
      input.style.borderColor = '#e0b4b4'
      input.style.backgroundColor = '#fff6f6'
      input.style.color = '#9f3a38'
    }

    var errorMessage = field.querySelector('.error-message')
    if (errorMessage) {
      errorMessage.textContent = message
      errorMessage.style.display = 'block'
    }

    this.updateSubmitButton()
  }

  clearFieldError(field) {
    field.classList.remove('error')
    var input = field.querySelector('input')
    if (input) {
      input.style.borderColor = ''
      input.style.backgroundColor = ''
      input.style.color = ''
    }

    var errorMessage = field.querySelector('.error-message')
    if (errorMessage) {
      errorMessage.textContent = ''
      errorMessage.style.display = 'none'
    }

    this.updateSubmitButton()
  }

  updateSubmitButton() {
    var self = this
    // Check for errors in installment fields (.installment-total-field, .installment-date-field)
    // or in other payment fields (.card-brand-field)
    var hasErrors = document.querySelectorAll('tr.installment-row .field.error, tr.nested-fields .field.error').length > 0
    var submitButton = document.querySelector('button[form="new-budget-order"]')

    if (submitButton) {
      if (hasErrors) {
        submitButton.disabled = true
        submitButton.classList.add('is-disabled')
        submitButton.style.opacity = '0.45'
        submitButton.style.cursor = 'not-allowed'
      } else {
        submitButton.disabled = false
        submitButton.classList.remove('is-disabled')
        submitButton.style.opacity = ''
        submitButton.style.cursor = ''
      }
    }
  }

  validateAllInstallments(parentRow) {
    var isValid = true
    var installmentRows = this.getInstallmentRows(parentRow)

    installmentRows.forEach(
      function(row) {
        var totalField = row.querySelector('.installment-total-field')
        var dateField = row.querySelector('.installment-date-field')

        if (totalField) {
          var input = totalField.querySelector('.installment-value-input')
          if (input && !this.validateTotal({ target: input })) {
            isValid = false
          }
        }

        if (dateField) {
          var input = dateField.querySelector('.installment-date-input')
          if (input && !this.validateDate({ target: input })) {
            isValid = false
          }
        }
      }.bind(this)
    )

    return isValid
  }

  validateCardBrand(event) {
    var paymentRow = event.target.closest('tr.nested-fields')
    if (!paymentRow) return true

    var paymentMethodSelect = paymentRow.querySelector('select[name*="[payment_method]"]')
    var cardBrandSelect = paymentRow.querySelector('select[name*="[card_brand_id]"]')

    if (!paymentMethodSelect || !cardBrandSelect) return true

    var paymentMethod = paymentMethodSelect.value
    var cardBrandField = cardBrandSelect.closest('.card-brand-field')

    if (!cardBrandField) return true

    this.clearFieldError(cardBrandField)

    if (paymentMethod === 'credit_card' || paymentMethod === 'debit_card') {
      if (!cardBrandSelect.value) {
        this.setFieldError(cardBrandField, 'A bandeira do cartão é obrigatória')
        return false
      }
    }

    return true
  }

  clearCardBrandError(event) {
    var cardBrandField = event.target.closest('.card-brand-field')
    if (cardBrandField) {
      this.clearFieldError(cardBrandField)
    }
  }

  setupFormSubmitListener() {
    var self = this
    var form = document.getElementById('new-budget-order')
    if (!form) return

    form.addEventListener('submit', function(event) {
      self.handleFormSubmit(event)
    })
  }

  handleFormSubmit(event) {
    var paymentRows = document.querySelectorAll('tr.nested-fields')
    var hasErrors = false

    paymentRows.forEach(
      function(paymentRow) {
        // Skip if this is an installment row (not a parent payment row)
        if (paymentRow.classList.contains('installment-row')) return

        var paymentMethod = this.getPaymentMethod(paymentRow)
        var installmentRows = this.getInstallmentRows(paymentRow)

        // Only validate if it's a billet payment with installments
        if (paymentMethod === 'billet' && installmentRows.length > 0) {
          if (!this.validateAllInstallments(paymentRow)) {
            hasErrors = true
          }
          // Note: Parent payment is already marked for destruction in handleInstallmentsChange()
          // when user selects > 1 installment
        }
      }.bind(this)
    )

    if (hasErrors) {
      event.preventDefault()
    }
  }

}
